import React, { Dispatch } from 'react';
import { TreeSelect } from 'antd';
import { connect } from 'react-redux';
import { IState } from '../../../types/interfaces';

interface IProps {
  treeData: { title: string; value: string }[];
  cb: Dispatch<string[]>;
  setCurValue: Dispatch<string>;
  cbSearch: (query: string, amount?: number) => void;
  values: string[];
  holder: string;
  value: string[];
  noSearch: string;
}

const SelectComponent = ({ treeData, cb, values, holder, value, noSearch, cbSearch, setCurValue }: IProps) => {
  const onChange = (currentValue: string[]) => {
    cb(currentValue);
  };
  const onSearch = (str: string) => {
    setCurValue(str);
    cbSearch(str, 100);
  };
  const onFocus = () => {
    setCurValue('');
  };

  const tProps = {
    onFocus,
    treeData,
    values,
    value,
    onChange,
    onSearch,
    notFoundContent: <div style={{ padding: '10px', textAlign: 'center' }}>{noSearch}</div>,
    treeCheckable: true,
    placeholder: holder,
    style: {
      width: '100%',
    },
  };
  return <TreeSelect {...tProps} />;
};

const mapStateToProps = (state: IState) => ({
  values: state.advancedSearch.okpd2_codes,
});

export default connect(mapStateToProps)(SelectComponent);
